// extracted by mini-css-extract-plugin
export default {"buttonText":"ButtonToggleSelectAll_buttonText__rHBNm"};